import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import Login from './routes/Login';
import Grid from './routes/Grid';
import Camera from './routes/Camera';
import { checkSession } from './lib/api';

type AuthState = 'loading' | 'authed' | 'anon';

export default function App() {
  const [auth, setAuth] = useState<AuthState>('loading');
  const location = useLocation();

  useEffect(() => {
    checkSession()
      .then((ok) => setAuth(ok ? 'authed' : 'anon'))
      .catch(() => setAuth('anon'));
  }, [location.pathname]);

  if (auth === 'loading') {
    return <div className="mono" style={{ padding: '2rem' }}>...</div>;
  }

  return (
    <Routes>
      <Route
        path="/login"
        element={auth === 'authed' ? <Navigate to="/" replace /> : <Login onAuthed={() => setAuth('authed')} />}
      />
      <Route
        path="/"
        element={auth === 'authed' ? <Grid /> : <Navigate to="/login" replace />}
      />
      <Route
        path="/camera/:id"
        element={auth === 'authed' ? <Camera /> : <Navigate to="/login" replace />}
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
